import React from 'react'
import products from '../../assets/homeone.png'


const HomeOne = () => {

  const scrollToForm = () => {
    const formSection = document.getElementById('contact-form');
    formSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <section className="hidden sm:flex relative w-full h-relative md:min-h-[45vh] lg:min-h-[55vh] xl:min-h-[80vh] items-center justify-start overflow-hidden bg-white">
        <div className="absolute inset-0  z-10" />
        <div className="flex flex-col lg:flex-row items-center justify-between w-full px-6 md:px-16 lg:px-24 py-8 gap-10">

          <div className="flex-1 flex justify-center">
            <img
              src={products}
              alt="ProductImage"
              className="w-full h-[500px] mt-0 object-contain"
            />
          </div>
          <div className="flex-1 flex flex-col items-start text-left">
            <h1
              className="text-3xl md:text-4xl font-bold text-[#44576D] mb-4 drop-shadow-lg"
              style={{ fontFamily: 'Segoe UI' }}
            >
              Boost Your Masculine Vitality <br />and Libido  Naturally
            </h1>
            <h2
              className="text-md md:text-md text-[#44576D] mb-6 leading-relaxed"
            >
              Experience Erexel - A clinically balanced herbal blend <br>
              </br> to enhance men’s energy, confidence, and performance.
            </h2>
            <ul class="list-disc pl-6 text-[#44576D] space-y-2">
              <li><strong>100% Natural Formula:</strong> Crafted from pure, plant-based ingredients for safe, lasting results.</li>
              <li><strong>No Stimulants or Fillers:</strong> Free from harsh chemicals, caffeine, or artificial additives.</li>
              <li><strong>Proudly Made in the USA:</strong> Manufactured in FDA-registered facilities under strict quality standards.</li>
            </ul>


            <button
              onClick={scrollToForm}
              className="bg-[#44576D] text-white font-semibold px-6 md:px-26 sm:px-6 py-3 md:py-4 rounded-md shadow hover:bg-white transition text-base md:text-lg mt-5"
            >
              Shop Now and Enjoy Free Worldwide Shipping
            </button>

          </div>


        </div>

      </section>

      <section className="flex sm:hidden relative w-full min-h-[90vh] flex-col items-center justify-end overflow-hidden capitalize">

        <div className="flex flex-col items-center justify-end w-full px-2 p-10 ml-2 z-20 ">
          <h1 className="text-3xl md:text-4xl font-bold text-[#44576D] mb-2 drop-shadow-lg text-left" style={{ fontFamily: 'Segoe UI' }}>
            Boost Your Masculine  <br />Vitalityand Libido Naturally
          </h1>

          <h2 className="text-[17px] text-[#44576D] mb-4 font-normal drop-shadow text-left" style={{ fontFamily: 'Segoe UI' }}>
            Experience Erexel - A clinically balanced herbal blend <br />
            to enhance men’s energy, confidence, and performance.
          </h2>

          <ul className="list-disc pl-6 text-[#44576D] space-y-2 text-left text-sm">
            <li><strong>100% Natural Formula:</strong> Crafted from pure, plant-based ingredients for safe, lasting results.</li>
            <li><strong>No Stimulants or Fillers:</strong> Free from harsh chemicals, caffeine, or artificial additives.</li>
            <li><strong>Proudly Made in the USA:</strong> Manufactured in FDA-registered facilities under strict quality standards.</li>
          </ul>


        </div>

        {/* Image below text */}
        <img
          src={products}
          alt="ProductImage"
          className="w-full h-[300px] object-contain z-10"
        />
        <button
          onClick={scrollToForm}
          className="bg-[#44576D] text-[#ffffff] font-semibold p-10 md:px-8 py-2 md:py-4 rounded-md shadow  text-base md:text-lg mt-4">
          Shop Now and Enjoy Free Shipping
        </button>

      </section>

    </>
  )
}

export default HomeOne
